module.exports = __webpack_public_path__ + "static/media/event.d07dd653.jpg";